import { ApiQuickInsightCategory } from "@incendium/api";
import { SvgIconProps } from "@mui/material";
import { getCategoryIcon } from "../utils";

function QuickInsightCategoryIcon({
  category,
  ...iconProps
}: {
  category: ApiQuickInsightCategory;
} & SvgIconProps) {
  const Icon = getCategoryIcon(category);
  return <Icon {...iconProps} />;
}

export default QuickInsightCategoryIcon;
